import { array, number, object } from "superstruct";

const EarnPointsProductVariantSchema = object({
    variantId: number(),
    pointsAmount: number(),
    storeCreditAmount: number(),
});

export const EarnPointsSchema = object({
    amountForProduct: object({
        productId: number(),
        pointsAmount: number(),
        storeCreditAmount: number(),
        variants: array(EarnPointsProductVariantSchema),
    }),
});
